module.exports={
  AllPage: {
    BT: '报停',
    OF: '离线',
    AllStatus: '全部状态',
    AllType: '全部对象',
    Alllevel: '全部等级',
    Tel: '热线电话',
    Us: '联系我们',
    Copyright: '版权所有',
    Notnormal: '异常',
    Isonline: '离线',
    Pleaseenteraname: '请输入名称',
    Pleaseenteracontent: '请输入内容',
    Memo: '备注',
    Time: '时间',
    PlzChoose: '请选择',
    PlzChoose2: '请选择状态',
    PlzChooseUser: '请选择用户',
    Plzchoosetime: '请选择日期区间',
    OverHandle: '事务处理',
    PlzinputSN: '请输入SN',
    Plzchoosedev: '请选择设备',
    Success: '成功',
    Sorry: '抱歉，网页走丢了.....',
    Cancel: '取消',
    Sure: '确定',
    Find: '查询',
    Add: '新增',
    Del: '删除',
    Edit: '编辑',
    Bind: '绑定',
    Operate: '操作',
    More: '更多',
    Save: '保存',
    Yes: '是',
    No: '否',
    Stime: '开始日期',
    Etime: '结束日期',
    Datatime: '数据时间',
    Classification: '请选择分类',
    Plzinput: '请输入设备名称或者SN',
    Name: '名称',
    Devname: '设备名称',
    Plzstatus: '请选择状态',
    Alltype: '全部分类',
    Download: '下载',
    Stop: '报停',
    Open: '启用',
    Isstop: '停用',
    All: '全部',
    Offline: '离线',
    Over: '超标',
    Warning: '预警',
    Normal: '正常',
    OverM: '即将超量',
    OverMo: '超量',
    Status: '状态',
    Model: '型号',
    Type: '分类',
    Port: '通道',
    Record: '记录间隔',
    Overps: '超标间隔',
    Address: '地址',
    Overport: '终端通道',
    Show: '查看',
    Danger: '危险',
    Usual: '常规',
    Renew: '续费',
    Belong: '所属',
    Look: '查看',
    Scrapp: '报废',

  },
  Header: {
    msg1: '智能在线',
    msg2: '智能判断，第一时间答复',
    msg3: '请输入您的问题',
    msg4: '疫苗冷链智能客服',
    msg5: 'Hi~我是智能助理，很高兴为您服务。请简述您的问题～～',
    Personal: '个人信息',
    GoBack: "返回云平台",
    Drop: "退出",
    Willbe: "将于",
    Expire: "到期",
    upgradeIcon: "续费升级 点亮图标",
    renewal: "立即续费",
    upgradeNow: "立即升级",
    Noticereminder: "公告提醒",
    Read: "我已阅读",
    WebAlarm: "声响报警",
    Datatransfer: "数据转移",
    Remind: "提醒",
    Msg: "您当前未加入公司，请选择创建或加入公司！",
    Joincompany: "加入公司",
    Startcompany: "创建公司",
    Invitationcode: "邀请码",
    line1: '各位亲爱的用户',
    line2: '为了更好地服务广大用户，适应社会潮流的改革发展，提高服务质量，新版温湿度数据监测平台测试服于2018年8月3日正式上线试运行，原温湿度数据监测平台的用户信息、公司信息等相关数据均已迁移到新平台中，为确保用户各项工作顺利进行，对新平台上线有关事项通知如下，请大家配合执行',
    line3: '一、系统访问方式',
    line4: '请各位用户通过原温湿度数据监测平台主页上方的“点击体验数据监测平台V3版（beta）”来访问新版温湿度数据监测平台测试服，或直接输入网址：https://cloud.hzjly.cn/，老用户的登录名和密码同原温湿度数据监测平台',
    line5: '二、核对数据信息',
    line6: '请老用户登陆新版温湿度数据监测平台测试服后核对相关数据信息是否有误，核对范围为',
    line7: '1、用户个人信息：用户名、真实姓名、性别、手机号码、电子邮箱、所在部门、报警方式',
    line8: '2、公司相关信息：公司名称、手机号码、所有者、所在区域、详细地址',
    line9: '如有错误，请将具体问题提交给杭州路格科技有限公司客户服务中心',
    line10: '三、主要事项',
    line11: '新版温湿度数据监测平台测试服于2018年8月8日方可进行历史数据查询。新版温湿度数据监测平台正式服务器上线将会清空所有测试服数据！详细的相关内容，请留意后续公告',
    line12: '四、系统操作手册',
    line13: '请各位用户自行前往系统公告下载操作手册，阅读新版温湿度数据监测平台测试服操作手册，熟悉新版温湿度数据监测平台测试服的使用方法。新版温湿度数据监测平台测试服上线后还将继续建设和完善一段时间，希望各位用户能一如既往地给予理解和支持，并在使用过程中多提宝贵意见，各位用户对新版温湿度数据监测平台测试服有任何建议意见，可直接联系杭州路格科技有限公司客户服务中心',
  },
  Index: {
    Dev: '设备',
    normal: '正常',
    over: '超标',
    offline: '离线',
    warn: '预警',
    allnum: '总数量',

    Monitoringobject: '监控对象',
    ChannelOK: '通道正常',
    Channeloutoflimit: '通道超标',
    Channeloffline: '通道离线',
    Channelstop: '通道报停',
    Numberofmonitoringobjects: '监控对象总数量',

    GPSpositioning: 'GPS定位',
    Latestannouncement: '最新公告',
    Noannouncementyet: '暂无公告',
    Yunxin: '云信(短信)',
    GoMsg: '请前往云信平台设置短信服务',
    Messagealert: '消息提醒',
    Nonewsyet: '暂无消息',

  },
  Nav: {
    Overview: '总览'
  },
  Rule: {
    Alarmrules: '报警规则',
    Pleaseenteranobjectname: '请输入对象名',
    Name: '名称',
    Type: '分类',
    Forcetime: '生效日期',
    Forcetime3: '免打扰时间',
    Forcetime2: '有效时间',
    AllDay: '全天免打扰',
    AllDayNot: '全天接收',
    Permanent: '永久有效',
    Stime: '开始时间',
    Etime: '结束时间',
    Open: '启用', //ADD
    Addalarmrule: '报警规则新增',
    Example: '示例',
    Startdate: '开始日期',
    Enddate: '结束日期',
    Alarmlevel: '报警层级',
    Level: '级',
    SMSalarm: '短信报警',
    Emailalarm: '邮箱报警',
    Voicealarm: '语音报警',
    WeChatalarm: '微信报警',
    Platformmessage: '平台消息',
    Globalobject: '全局对象',
    Specifyuser: '指定用户',
    Platformusers: '平台用户',
    contacts: '联系人',
    increase: '增加',
    Alarmdelay: '报警延迟',
    Alarmcycle: '报警周期',
    Addlevel: '添加层级',
    Deletelevel: '删除层级',
    Rulelist: '规则列表',
    Grade: '等级',
    Heuristiccondition: '启发条件',
    Newcontact: '新增联系人',
    Nickname: '昵称',
    Telephone: '电话',
    Email: '邮箱',
    Addedsuccessfully: '成功!',
    Msg: '您需要将当前规则绑定到对应设备!',
    Bindnow: '立即绑定!',
    Bindlater: '稍后绑定!',
    Howalarm: '如何开启微信报警!', //Bind
    Bindalarm: '报警规则绑定',
    Range: '范围',

    //Detial
    Detial: '报警规则详情',
    List: '规则列表', //Edit
    Edit: '报警规则编辑', //Log
    Log: '报警记录',
    AlarmLevel2: '报警级别',
    AlarmTime: '报警时间',
    Content: '内容',
    AlarmUser: '报警用户',
  },
  Cold: {
    Coldsystem: '冷链装备评估体系',
    Enternumber: '请输入冷链设备号',
    Unittype: '单位类型',
    Unit: '单位',
    DevNo: '冷链设备号',
    Type: '类型',
    Activationdate: '启用日期',
    Brandmode: '品牌型号',
    average: '平均温度',
    max: '最高温度',
    min: '最低温度',
    alarmtimes: '超温报警次数',
    failuresnum: '设备故障次数',
    evaluationvalue: '冷链管理评估值',

    List: '冷链装备列表',
    Buytime: '采购时间',
    volume: '冷链容积',
    Manufactor: '厂家',
    brand: '品牌',
    Specification: '规格型号',
    Maintenancerecord: '维修记录',

    evaluationsystem: '冷链单位评估体系',
    Excel: '导出Excel',
    Allnum: '冷链设备总数',
    AlarmNum: '报警总数',
    humancaused: '人为造成次数',
    nothandledtime: '未及时处理次数',
    noplatform: '未按属定登录平台次数',
  },
  Msg: {
    Messagemanagement: '消息管理',
    Notice: '公告',
    Title: '标题',
    briefintroduction: '简介',
    content: '内容',
    Creationtime: '创建时间',
  },
  Log: {
    Devlog: '设备日志',
    Monlog: '监控对象日志',

    Userlog: '用户日志',

    selectalevel: '请选择等级',
    devname: '设备名称',
    contents: '内容',
    showlevel: '危险等级',
    typename: '日志分类',
    username: '操作人',

    Monname: '监控对象名称',
    Plzinputmon: '请输入监控对象',
  },
  Dev: {
    user: '用户名',
    title: '标题',
    deploy: '配置客户信息',
    Devlist: '设备列表',
    Plzlocation: '请选择定位',
    Plzsort: '请选择排序',
    Sort: '排序',
    Card: '卡片',
    localion: '定位',
    smsinfo: '本月已发送/剩余',
    Expire: '到期',
    nosms: '无短信服务',
    Data: '日志',
    Alarmrule: '报警规则',
    Bindcard: '绑定卡片',
    Finish: '完成',
    Msg1: '警告 : 该操作将会删除该设备。如确认删除，请如下操作。',
    Msg2: '请输入SN以确认',
    Msg3: '设备删除成功',
    Msg4: '一键填写',
    Basic: '基本信息',
    InputCard: '卡片录入',
    Hz: '无线通讯频率',
    Plzhz: '请选择频率',
    Newadd: '新增数量',
    Newaddcard: '新增卡片录入',
    Search: '搜索',
    Newdev: '新增设备',
    Edittype: '设备分类',
    Cardnum: '卡号',
    localtype: '定位类型',
    temperature: '温度',
    humidity: '湿度',
    portinfo: '通道信息',
    tips: '提示',
    Msg5: '设备同步成功',
    Msg6: '设备同步超时',
    Msg7: '设备不在线，等待设备链接后自动同步',
    Msg8: '设备同步中,请耐心等待',
    Devedit: '设备编辑',
    Devdetial: '设备详情',
    excessive: '超标阀值',
    harbinger: '预警阀值',
    Msg9: '修改通道名称',


    devlocation: '设备定位',
    Msg10: '刷新时间 : 1分钟',
    gpslon: '经度',
    gpslat: '纬度',
    playback: '回放',
    stop: '暂停',
    speed: '回放速度',
    path: '运行轨迹',
    index: '序号',
    locationtime: '定位时间',
    data: '数据',
    locationadr: '定位',

    view: '设备视图',
    DevFiles: '冷链档案',
  },
  DataHandle: {
    msg1: '添加事务处理',
    msg2: '添加事务处理',
    time: '时间',
    reason: '原因',
    overdev: '设备',
    overHandle: '事务处理(设备)',
    operator: '操作人',
    devnames: '处理设备',
    createtime: '处理时间',

  },
  DevCurve: {
    msg1: '历史曲线(设备)',
    msg2: '是否展示上下限',
    msg3: '历史曲线(设备)(二版)',
    portname: '通道名',
    uplow: '上下限',
    max: '最大值',
    min: '最小值',
    avg: '平均值',
    jc: '极差',
    fc: '方差',
    bzc: '标准差',
  },
  DevHistory: {
    msg1: '历史数据(设备)',
    print: '打印',
    devsn: '设备编号',
    portdata: '通道数据',
    msg2: '超标数据(设备)',
    msg3: '超标数据(设备)(二版)',
    msg4: '历史数据(设备)(二版)',

  },
  Mon: {
    MonView: '监控对象视图',
    mon: '监控对象',
    bd: '布点',
    fp: '分配',
    xgsxx: '修改上下限',
    bdt: ' 布点图',
    reupload: ' 重新上传',

    title: '维修记录',
    title2: '报修设备',
    register: '报修人',
    registertime: '报修时间',
    registercontent: '报修内容',
    repairer: '维修人',
    repairstate: '处理结果',
    repairtime: '处理时间',

    title3: '监控对象新增',
    purchasetime: '采购时间',
    img: '平面图',
    msg: '关联监控对象',
    title4: '历史曲线(监控对象)',
    NameVal: '最小对象名',

    title5: '分配对象-分配',
    msg2: '监控对象',
    msg3: '选择监控对象',
    Monchild: '设备名称',
    createtime: '创建时间',
    msg4: '已选择子集',
    msg5: '已选择',

    title6: '监控对象详情',
    title7: '监控对象编辑',
    title8: '历史数据(监控对象)',
    title9: '监控对象',
    title10: '事务数据(监控对象)',
    title11: '监控对象列表',

    msg6: '警告',
    msg7: '该操作将会删除该监控对象。如确认删除，请如下操作',
    msg8: '请输入监控对象名称以确认',
    msg9: '监控对象名称',
    msg10: '监控对象删除成功',
    msg11: '通道名称',
    rebind: '重新关联',
    title12: '分配对象',

    name: '昵称',
    tel: '电话',
    email: '邮箱地址',
    alarmtype: '报警方式',

  },
  JS: {
    //this.$t('JS.devalarm')
    lastweek: '最近一周',
    lastmonth: '最近一个月',
    lasttmonth: '最近三个月',
    devalarm: '设备报警',
    trans: '数据转移中....',
    transError: '数据转移失败,请联系相关管理人员....',
    codeinfo: '邀请码不能为空',
    willdel: '此操将会删除, 是否继续?',
    willstop: '此操将会报停, 是否继续?',
    tip: '提示',
    sure: '确定',
    cancel: '取消',
    msg: '暂无数据',
    msg1: '请填写电话号码',
    msg2: '请选择规则',
    msg3: '请选择报警方式',
    msg4: '联系方式为空',
    msg5: '请正确填写内容',
    msg6: '已存在',

    one: '自定义区间',
    day: '本日',
    week: '本周',
    month: '本月',
    show: '展示',
    hide: '隐藏',
    portval: '通道值',


    devmsg1: '请选择时间',
    devmsg2: '请填写超标原因',
    devmsg3: '记录间隔不能小于超标间隔',
    devmsg4: '请先搜索SN获取完整通道信息',
    devmsg5: '有数据为空',
    devmsg6: '超标下限不能大于或等于上限',
    devmsg7: '预警下限不能大于或等于上限',
    devmsg8: '请输入设备',
    devmsg9: '名称长度需小于5个字符',
    devmsg10: '请先至少有一条卡片数据',
    devmsg11: '请先填入完整SN',
    devmsg12: '型号不能为空',
    devmsg13: '记录间隔不能为空',
    devmsg14: '超标间隔不能为空',
    devmsg15: '请选择分类',
    devmsg16: '卡片信息数据不能为空',
    devmsg17: '卡片数据不能为空',
    devmsg18: '错误',

    devmsg19: '全部定位',
    devmsg20: '无',
    devmsg21: '基站定位',
    devmsg22: 'GPS定位',

    srot1: '默认排序',
    srot2: '名称(正序)',
    srot3: '名称(倒序)',
    srot4: 'SN(正序)',
    srot5: 'SN(倒序)',
    srot6: '序号(正序)',
    srot7: '序号(倒序)',

    viewmsg1: '已超过有效期.以下服务将受到影响',
    viewmsg2: '报警服务',
    viewmsg3: '历史数据查询',
    viewmsg4: '曲线查询',
    viewmsg5: '定位轨迹回放',
    viewmsg6: '数据导出',
    viewmsg7: '请点击续费按钮进行续费来恢复服务',
    viewmsg8: '服务受限',
    viewmsg9: '（温馨提示：若超过一个月未续费，卡将被注销且无法上传数据，届时需要重新购买物联网卡）',

    monmsg: '暂无布点',
    monmsg2: '上传图片只能是 JPG 或 PNG 格式',
    monmsg3: '请先上传布点图',
    monmsg4: '请选择关联对象',
    monmsg5: '请输入监控对象',
    monmsg6: '采购时间不能为空',
    monmsg7: '名称错误',


    indexmsg: '短信余量',
    indexmsg2: '总数量',
    indexmsg3: '正常',
    indexmsg4: '即将过期',
    indexmsg5: '已过期',
    indexmsg6: '短信服务期',


    Pd:'盘点',
    Gh:'更换',
    BT:'报停',
    QY:'启用',
    PLCL:'批量处理',
    KSBT:'开始报停',
    YCZ:'异常中',
    DCL:'待处理',
    YCL:'已处理',
    TZBT:'停止报停',
    XCXKSBT:'小程序开始报停',
    XCXJSBT:'小程序结束报停',
    MC:'名称',
    FL:'分类',
    TDS:'通道数',
    KSSJ:'开始时间',
    JSSJ:'结束时间',
    JLTS:'记录条数',
    CBTS:'超标条数',
    HGL:'合格率',
  },

}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js